function logBlock(log, context) {
  log.error(`iframe-only-check BLOCK ${context.host}: !iframe && iframeOnly`, context)
}

const whiteListNoIframeRoutes = [
  '/guest/additional-owner',
  '/guest/additional-owner/post-offer-docs',
  '/embedded/docusign-redirect', // DocuSign redirect handler - unauthenticated route
]

export { whiteListNoIframeRoutes }

export async function iframeOnlyCheck({ route, identityStore, requestURL, log }) {
  const context = { host: requestURL.host, origin: requestURL.origin }

  try {
    if (route && whiteListNoIframeRoutes.includes(route.path)) {
      // Whitelisted routes are always ok
      return
    }
    // in iframe?
    const iframe = window.self !== window.top
    context.iframe = iframe

    // allow iframe
    if (iframe) {
      return
    }

    // allow if not iframe only origin
    let iframeOnly = false;
    iframeOnly = await identityStore.isIframeOnly()
    context.iframeOnly = iframeOnly

    if (!iframeOnly) { // allow
      return
    }

    // block, non-iframe on iframe only origin
    logBlock(log, context)

    return showError({
      statusCode: 404,
      statusMessage: 'Page not found'
    })
  } catch (err) {
    // given that this is a deterrent and not a security measure,
    // we ignore errors to avoid noise
    // there are other things that will fail if we are not in an iframe
    // on an iframe only origin
    return
  }
}
